import {Responsive, Font} from '@oneamerica/dxp-ui-components';
import ColorConstants from '../../constants/ColorConstants';

const createErrorStyles = () =>
  Responsive.create({
    errorInfo: {
        fontSize: 15,
        color: ColorConstants.blackText,
        fontWeight: Font.regular.fontWeight,
        fontFamily: Font.regular.fontFamily,
        textAlign: 'center'
    },
  })();
export default createErrorStyles;
